<template>
    <div class="overlay">
        <div class="overlay-content">
            <slot name="content"></slot>
        </div>

        <div class="info-area" :class="{'de': $i18n.locale == 'de', 'en': $i18n.locale == 'en'}">
            <img :src="imagePath('Group 1234')">
            
            <slot name="info"></slot>
        </div>

        <img :src="imagePath(satelite)" class="satelite">

        <img :src="imagePath('warbenmini')" class="warben-bg">
        <img :src="imagePathPng(image)" class="big-image">

        <button @click="$emit('close')" class="backbutton-overlay">
            <img :src="imagePath('backbutton-grey')">
        </button>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String,
            defaeult: '',
        },

        satelite: {
            type: String,
            defaeult: '',
        },
    },

    methods: {
        imagePath: function (fileName) {
            if(fileName != '')
                return require('../assets/icons/' + fileName + '.svg')
        },

        imagePathPng: function (fileName) {
            if(fileName != '')
                return require('../assets/icons/' + fileName + '.png')
        }
    }
}
</script>

<style scoped>
.overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 1920px;
    height: 1080px;
    /* UI Properties */
    background: #EFEFEF 0% 0% no-repeat padding-box;
    opacity: 1;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    z-index: 2000;
}

.backbutton-overlay {
    position: absolute;
    top: 265px;
    left: 328px;
    width: 101px;
    height: 87px;
    opacity: 1;
    cursor: pointer;
    background-color: transparent;
    border: none;
}

.big-image {
    position: absolute;
    top: 272px;
    left: 282px;
    width: 615px;
    height: 533px;
}

.warben-bg {
    position: absolute;
    top: 288px;
    left: 673px;
    width: 200px;
    height: 468px;
}

.overlay-content {
    position: absolute;
    top: 342px;
    left: 620px;
    width: 500px;
    height: 320px;
    background: #FDFDFD 0% 0% no-repeat padding-box;
    border-radius: 14px;
    opacity: 1;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    padding-top: 30px;
    padding-left: 260px;
    padding-right: 50px;
    text-align: left;
    font-family: 'Regular';
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.1px;
}
.overlay-content p  {
    width: 466px;
    font-family: Regular;
    font-size: 16px;
}

.overlay-content h3 {
    font-family: 'CorpBold';
    font-size: 42px;
    line-height: 46px;
    letter-spacing: 1.76px;
    color: #363636;
}

.info-area {
    position: absolute;
    display: flex;
    align-items: center;
    top: 948px;
    left: 486px;
    height: 30px;
    /* UI Properties */
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 41px;
    padding: 12px 20px 12px 12px;
}

.info-area img {
    margin-right: 20px;
    height: 23px;
    width: 23px;
}

.info-area p {
    font-family: 'Demi';
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-align: left;
    color: #000;
}

.satelite {
    position: absolute;
    top: 640px;
    left: 240px;
    width: 187px;
    height: 162px;
}

@media only screen and (max-device-width: 1024px) {
    .overlay {
        width: 100%;
        height: 100%;
    }

    .backbutton-overlay {
        top: 125px;
        left: 45px;
    }

    .backbutton-overlay img {
        width: 80px;
        height: 66px;
    }

    .big-image {
        top: 135px;
        left: 12px;
        width: 515px;
        height: 433px;
    }

    .warben-bg {
        top: 123px;
        left: 330px;
        width: 180px;
        height: 438px;
    }

    .overlay-content {
        top: 175px;
        left: 300px;
        width: 440px;
        height: 300px;
        padding-top: 15px;
        padding-left: 220px;
        padding-right: 50px;
        font-size: 15px;
    }

    .overlay-content h3 {
        font-size: 32px;
        line-height: 38px;
    }

    .overlay-content h4 {
        text-align: left;
        font-family: Demi;
        font-size: 16px;
        line-height: 32px;
        color: #043171;
    }

    .info-area {
        top: 580px;
        height: 25px;
        padding: 12px 20px 12px 12px;
    }

    .info-area p {
        font-size: 13px;
    }

    .satelite {
        top: 445px;
        left: 15px;
        width: 117px;
        height: 112px;
    }

    .de {
        left: 30px;
    }

    .en {
        left: 170px;
    }
}

@media only screen and (max-device-width: 1366px) {
    .overlay {
        width: 100%;
        height: 100%;
    }

    .backbutton-overlay {
        top: 125px;
        left: 95px;
    }

    .backbutton-overlay img {
        width: 80px;
        height: 66px;
    }

    .big-image {
        top: 135px;
        left: 62px;
        width: 515px;
        height: 433px;
    }

    .warben-bg {
        top: 123px;
        left: 380px;
        width: 180px;
        height: 438px;
    }

    .overlay-content {
        top: 175px;
        left: 350px;
        width: 440px;
        height: 300px;
        padding-top: 15px;
        padding-left: 220px;
        padding-right: 50px;
        font-size: 15px;
    }

    .overlay-content h3 {
        font-size: 32px;
        line-height: 38px;
    }

    .overlay-content h4 {
        text-align: left;
        font-family: Demi;
        font-size: 16px;
        line-height: 32px;
        color: #043171;
    }

    .info-area {
        top: 580px;
        height: 25px;
        padding: 12px 20px 12px 12px;
    }

    .info-area p {
        font-size: 13px;
    }

    .satelite {
        top: 445px;
        left: 65px;
        width: 117px;
        height: 112px;
    }

    .de {
        left: 120px;
    }

    .en {
        left: 220px;
    }
}
</style>